import React from 'react';
import Banner from './Header/Banner';
import Header from './Header/Header';
import Services from './Services/Services';
import Portfolio from './Portfolio/Portfolio';
import Blog from './Blog/Blog';
import Contact from './Contact/Contact';
import Footer from './Footer/Footer';

const Home = () => {
  return (
    <div className="container">
      <Header></Header>
      <Banner></Banner>
      <Services></Services>
      <Portfolio></Portfolio>
      <Blog></Blog>
      <Contact></Contact>
      <Footer></Footer>
    </div>
  );
};

export default Home;
